/* Pure Grounds: keeps a heading within a line count on phones by shrinking its font.
   Markup: data-fit-lines="2" on the heading (image-banner heading block, "Phone line limit"). The largest
   size is the block's phone size (--banner-heading-phone-size, in vw) or the stylesheet size; the font then
   binary-searches down to the biggest size that still fits. Runs at load, again when the web fonts arrive,
   on resize and when the theme editor reloads a section. */
(function () {
  'use strict';
  var PHONE_MAX = 749;

  function lineCount(el) {
    var range = document.createRange();
    range.selectNodeContents(el);
    var rects = range.getClientRects();
    var seen = {};
    var n = 0;
    for (var i = 0; i < rects.length; i++) {
      if (rects[i].width <= 0) continue;
      var top = Math.round(rects[i].top);
      if (!seen[top]) {
        seen[top] = true;
        n++;
      }
    }
    return n;
  }

  function fit(el) {
    var lines = parseInt(el.getAttribute('data-fit-lines'), 10);
    if (!lines) return;
    el.style.fontSize = '';
    if (window.innerWidth > PHONE_MAX) return;
    var styles = getComputedStyle(el);
    var vw = parseFloat(styles.getPropertyValue('--banner-heading-phone-size'));
    var max = vw ? (vw * window.innerWidth) / 100 : parseFloat(styles.fontSize);
    if (!max) return;
    el.style.fontSize = max + 'px';
    if (lineCount(el) <= lines) return;
    var lo = max * 0.5;
    var hi = max;
    for (var i = 0; i < 9; i++) {
      var mid = (lo + hi) / 2;
      el.style.fontSize = mid + 'px';
      if (lineCount(el) <= lines) lo = mid;
      else hi = mid;
    }
    el.style.fontSize = Math.floor(lo * 10) / 10 + 'px';
  }

  function fitAll() {
    var els = document.querySelectorAll('[data-fit-lines]');
    for (var i = 0; i < els.length; i++) fit(els[i]);
  }

  fitAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(fitAll, 150);
  });
  document.addEventListener('shopify:section:load', fitAll);
})();
